import { gsap, ScrollTrigger } from "gsap/all";

export function fadeUpCards() {
  gsap.registerPlugin(ScrollTrigger);
  const animationDuration = 0.8;
  const fadeUpDistance = 8;
  const startPosition = "top 80%";
  const ease = "power2.inOut";

  const wrappers = document.querySelectorAll(".fade-up-card-wrapper");

  wrappers.forEach((wrapper) => {
    const elements = wrapper.querySelectorAll(".fade-up-card");

    elements.forEach((element, index) => {
        gsap.from(element, {
            y: fadeUpDistance * index,
            opacity: 0,
            duration: animationDuration,
            ease: ease,
            scrollTrigger: {
                trigger: element,
                start: startPosition,
                // markers: true,
            }
        });
        gsap.fromTo(element, {
            "--before-scale": 0,
        }, {
            "--before-scale": 1,
            duration: animationDuration,
            ease: ease,
            scrollTrigger: {
                trigger: element,
                start: startPosition,
                // markers: true,
            }
        });
    });
  });
}